import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import businessModelActions from '../actions/businessModel';

// responds to 'GET_ADVERTISER_BUSINESS_MODEL' action
function getAdvertiserBusinessModel(store) {
    // Get the current state to extract the correct IDs
    const state = store.getState();
    const userInfoMetadata = state.userInfoDetails?.userInfoMetadata || {};
    const softwareDetails = state.softwareDetails || {};

    if (!userInfoMetadata.ipm && !softwareDetails.systemId && !softwareDetails.softwareId && !softwareDetails.onboardAdvertiserDetails) {
        return;
    }
    
    const systemId = softwareDetails.systemId || 
                    softwareDetails.onboardAdvertiserDetails?.systemId ||
                    userInfoMetadata.ipm?.resellerName ||
                    userInfoMetadata.ipm?.externalSystemId;
                    
    const advertiserId = softwareDetails.softwareId || 
                        softwareDetails.onboardAdvertiserDetails?.externalId ||
                        userInfoMetadata.ipm?.externalId;
    
    // Only proceed with API call if we have all identifiers
    if (!systemId && !advertiserId) {
        // No required data available, exit gracefully
        return;
    }
    
    const apiUrl = `/${config.url_prefix}/api/advertiser/businessModel`;
    
    // Add query parameters if we have the required values
    const queryParams = new URLSearchParams();
    if (advertiserId) {
        queryParams.append('advertiserId', advertiserId);
    }
    if (systemId) {
        queryParams.append('systemId', systemId);
    }
    
    const finalUrl = `${apiUrl}?${queryParams.toString()}`;
    
    request.get(finalUrl)
        .end((error, response) => {
            if (error) {
                store.dispatch(businessModelActions.alertError('internal.server.error'));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (!parsedResponse || response.statusCode >= 400 || response.code >= 400) {
                        store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
                    } else {
                        const businessModelType = parsedResponse.businessModel;
                        
                        if (businessModelType) {
                            store.dispatch(businessModelActions.getAdvertiserBusinessModelSuccess(businessModelType));
                        } else {
                            store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
                        }
                    }
                } catch (exp) {
                    store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
                }
            }
        });
}

export default getAdvertiserBusinessModel;
